import React from 'react';
import {
  UserOutlined,
  UnlockOutlined,
  SettingOutlined,
  MenuOutlined,
  InteractionOutlined,
  RetweetOutlined,
  UnorderedListOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FormOutlined,
  DatabaseOutlined,
  SwapOutlined,
  AuditOutlined,
  ReconciliationOutlined,
  AlertOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import constants from '../constants';

export const Modules = [
  {
    type: 'list',
    title: 'Jobchart',
    key: 'Jobchart',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createJobchart',
        title: 'Create',
        key: 'Create Jobchart',
        link: '/jobcharts/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'jobchartList',
        title: 'List',
        key: 'Jobchart List',
        link: '/jobcharts/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Fabric Inventory',
    key: 'Fabric Inventory',
    icon: <InteractionOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'fabricInventory',
        title: 'Inventory',
        key: 'Fabric_Inventory',
        link: '/inventory/fabric',
        icon: <DatabaseOutlined />,
      },
      {
        type: 'item',
        module: 'modifyFabricInventory',
        title: 'Add',
        key: 'Add Fabric',
        link: '/inventory/fabric/add',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'fabricInventoryTransferRequestList',
        title: 'Transfer Requests',
        key: 'Fabric Transfer Requests',
        link: '/inventory/fabric/transfer/list',
        icon: <SwapOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Accessory Inventory',
    key: 'Accessory Inventory',
    icon: <InteractionOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'accessoryInventory',
        title: 'Inventory',
        key: 'Accessory_Inventory',
        link: '/inventory/accessory',
        icon: <DatabaseOutlined />,
      },
      {
        type: 'item',
        module: 'modifyAccessoryInventory',
        title: 'Add',
        key: 'Add Accessory',
        link: '/inventory/accessory/add',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'accessoryInventoryTransferRequestList',
        title: 'Transfer Requests',
        key: 'Accessory Transfer Requests',
        link: '/inventory/accessory/transfer/list',
        icon: <SwapOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Store Inward',
    key: 'Store Inward',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createStoreInward',
        title: 'Create',
        key: 'Create Store Inward',
        link: '/storeinward/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'storeInwardList',
        title: 'List',
        key: 'Store Inward List',
        link: '/storeinward/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'item',
    title: 'Quality Checks',
    key: 'Quality Check List',
    icon: <AuditOutlined />,
    module: 'qualityCheckList',
    link: '/qualitycheck/list',
  },
  {
    type: 'list',
    title: 'Store Outward',
    key: 'Store Outward',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createStoreOutward',
        title: 'Create',
        key: 'Create Store Outward',
        link: '/storeoutward/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'storeOutwardList',
        title: 'List',
        key: 'Store Outward List',
        link: '/storeoutward/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Purchase Order',
    key: 'Renuka PO',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createRenukaPO',
        title: 'Create',
        key: 'Create Renuka PO',
        link: '/renukapo/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'renukaPOList',
        title: 'List',
        key: 'Renuka PO List',
        link: '/renukapo/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'item',
    title: 'Debit Notes',
    key: 'Debit Note List',
    icon: <UnorderedListOutlined />,
    module: 'qualityCheckList',
    link: '/debitnote/list',
  },
  {
    type: 'list',
    title: 'Issue Receive',
    key: 'Issue Receive',
    icon: <RetweetOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'issueReceive',
        title: 'Issue Form',
        key: 'Create Issue Receive',
        link: '/issuereceive/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'viewChallan',
        title: 'Challan List',
        key: 'Challan List',
        link: '/issuereceive/challan',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Workers & Jobs',
    key: 'Workers & Jobs',
    icon: <RetweetOutlined />,
    subModules: [
      {
        type: 'item',
        module: constants.permissions.workerList,
        title: 'Workers',
        key: 'Worker List',
        link: '/workers/list',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: constants.permissions.createWorker,
        title: 'Add Worker',
        key: 'Add Worker',
        link: '/workers/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: constants.permissions.workerIssueList,
        title: 'Issue List',
        key: 'Worker Issues',
        link: '/workers/issues',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: constants.permissions.addWorkerIssue,
        title: 'Issue Styles',
        key: 'Add Issue',
        link: '/workers/issues/add',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: constants.permissions.workerJobList,
        title: 'Jobs',
        key: 'Worker Jobs',
        link: '/workers/jobs',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: constants.permissions.addWorkerJob,
        title: 'Add Job',
        key: 'Add Job',
        link: '/workers/jobs/add',
        icon: <FormOutlined />,
      },
    ],
  },
  {
    type: 'item',
    title: 'MRR',
    key: 'MRR',
    icon: <ReconciliationOutlined />,
    module: 'MRR',
    link: '/mrr',
  },
  {
    type: 'item',
    title: 'Outward Report',
    key: 'Outward Report',
    icon: <ReconciliationOutlined />,
    module: 'outwardReport',
    link: '/outwardReport',
  },
  {
    type: 'item',
    title: 'Weekly Plan',
    key: 'Weekly Plan',
    icon: <CalendarOutlined />,
    module: 'weeklyPlan',
    link: '/weeklyplan',
  },
  // Performance & Deadlines — gated on Notify's OWN sections (fetched at login
  // as `notify:*` pseudo-permissions), so the ERP never duplicates Notify's
  // RBAC. Notify is the single source of truth for who sees what here.
  {
    type: 'list',
    title: 'Performance & Deadlines',
    key: 'Performance & Deadlines',
    icon: <AlertOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'notify:perf',
        title: 'Performance',
        key: 'Performance',
        link: '/performance',
        icon: <BarChartOutlined />,
      },
      {
        type: 'item',
        module: 'notify:extensions',
        title: 'Task Extensions',
        key: 'Task Extensions',
        link: '/extensions',
        icon: <ClockCircleOutlined />,
      },
      {
        type: 'item',
        module: 'notify:approvals',
        title: 'Approvals',
        key: 'Extension Approvals',
        link: '/extensions/approvals',
        icon: <AuditOutlined />,
      },
    ],
  },
  {
    type: 'item',
    title: 'T&A Tracking',
    key: 'T&A Tracking',
    icon: <AlertOutlined />,
    module: 'userTimeAndActionTracking',
    link: '/timeactions/tracking',
  },
  {
    type: 'list',
    title: 'Daily Completion',
    key: 'Daily Completion',
    icon: <ClockCircleOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'dailyCompletionForm',
        title: 'Form',
        key: 'Daily_Completion_Form',
        link: '/dailycompletion/form',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'dailyCompletionList',
        title: 'List',
        key: 'Daily_Completion_List',
        link: '/dailycompletion/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Sample',
    key: 'Sample',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createSample',
        title: 'Create',
        key: 'Create Sample',
        link: '/samples/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'sampleList',
        title: 'List',
        key: 'Sample List',
        link: '/samples/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Cost Sheet',
    key: 'Cost Sheet',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createCostSheet',
        title: 'Create',
        key: 'Create Cost Sheet',
        link: '/costsheet/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'costSheetList',
        title: 'List',
        key: 'Cost Sheet List',
        link: '/costsheet/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Product',
    key: 'Product',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createProduct',
        title: 'Create',
        key: 'Create Product',
        link: '/products/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'productList',
        title: 'List',
        key: 'Product List',
        link: '/products/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Style',
    key: 'Style',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createStyle',
        title: 'Create',
        key: 'Create Style',
        link: '/styles/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'styleList',
        title: 'List',
        key: 'Style List',
        link: '/styles/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Fabric',
    key: 'Fabric',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createFabric',
        title: 'Create',
        key: 'Create Fabric',
        link: '/fabrics/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'fabricList',
        title: 'List',
        key: 'Fabric List',
        link: '/fabrics/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Accessory',
    key: 'Accessory',
    icon: <MenuOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createAccessory',
        title: 'Create',
        key: 'Create Accessory',
        link: '/accessories/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'accessoryList',
        title: 'List',
        key: 'Accessory List',
        link: '/accessories/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Dropdowns',
    key: 'Dropdowns',
    icon: <SettingOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'unitList',
        title: 'Units',
        key: 'Units',
        link: '/dropdowns/units',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: 'colorList',
        title: 'Colors',
        key: 'Colors',
        link: '/dropdowns/colors',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: 'factoryList',
        title: 'Factories',
        key: 'Factories',
        link: '/dropdowns/factories',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: 'rackList',
        title: 'Rack',
        key: 'Rack',
        link: '/dropdowns/racks',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Customer',
    key: 'Customer',
    icon: <UserOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createCustomer',
        title: 'Create',
        key: 'Create Customer',
        link: '/customers/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'customerList',
        title: 'List',
        key: 'Customer List',
        link: '/customers/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Vendor',
    key: 'Vendor',
    icon: <UserOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createVendor',
        title: 'Create',
        key: 'Create Vendor',
        link: '/vendors/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'vendorList',
        title: 'List',
        key: 'Vendor List',
        link: '/vendors/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },

  {
    type: 'list',
    title: 'User',
    key: 'User',
    icon: <UserOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createUser',
        title: 'Create',
        key: 'Create User',
        link: '/users/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'userList',
        title: 'List',
        key: 'User List',
        link: '/users/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
  {
    type: 'list',
    title: 'Role',
    key: 'Role',
    icon: <UnlockOutlined />,
    subModules: [
      {
        type: 'item',
        module: 'createRole',
        title: 'Create',
        key: 'Create Role',
        link: '/roles/create',
        icon: <FormOutlined />,
      },
      {
        type: 'item',
        module: 'roleList',
        title: 'List',
        key: 'Role List',
        link: '/roles/list',
        icon: <UnorderedListOutlined />,
      },
    ],
  },
];

export const getSubModules = modules => {
  const list = [];

  modules.map(({ type, module, subModules }) => {
    if (type === 'item') {
      list.push(module);
    } else if (type === 'list') {
      list.push(...getSubModules(subModules));
    }
  });

  return list;
};

const moduleLinkings = {};

Modules.map(el => {
  if (el.subModules && el.subModules.length) {
    el.subModules.map(({ key, link }) => {
      moduleLinkings[link] = key;
    });
  }
});

export const getDefaultSelectedKeys = (link = '') => moduleLinkings[link];
